import React, { useEffect, useMemo, useRef, useState } from 'react';
import { StyleSheet, View, Text, Easing, Animated } from 'react-native';
import { KView, PageContext } from '@/component/RtlLayout';
import { convertStyles } from '@kibt/krn-utils';

import SrcStyles from './index.styl';
import AnimatedGradientTransition from '@/component/AnimatedLinearGradient';
import { useShowFlash } from '@/hooks/abTest/useShowFlash';
import { showFlashActivity } from '../../utils';
import flashPng from '@/assets/icon_detail/banner_flash.png';
import { k18nPro } from '@/component/k18n/K18n';
import useShowBottomBenefits from '@/hooks/abTest/useShowBottomBenefits';
import { $k18n } from '@/page/orderDetail/view/utils/tools';
import { useDetailPageStore } from '@/page/detail/store';
import useShowGuarantee from '@/hooks/useShowGuarantee';
import { CountDownTag } from '@/business-components/CountDownTag';
import { ActivityType, ItemInfo } from '../Exclusive/CaculateBlock';
import useCountDown from '@/hooks/common/useCountDown';
import { useSubsidy } from '../../hooks/useSubsidy';
import Image from '@kds/image';
import { PageRowData } from '../../../api';

const Styles = convertStyles(SrcStyles);

const styles = StyleSheet.create({
    linearWrap: {
        position: 'relative',
        height: 32,
        width: '100%',
        color: 'rgba(0, 0, 0, 0.88)',
    },
    textarea: {
        flexDirection: 'row',
        // alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        height: 32,
    },
    bannerImage: {
        width: 20,
        height: 20,
    },
    bannerText: {
        fontSize: 14,
        lineHeight: 32,
        color: 'black',
    },
    specbannerText: {
        fontSize: 14,
        lineHeight: 32,
        color: 'black',
        textAlign: 'center',
        width: '100%',
    },
    guaranteeArea: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: 32,
        paddingLeft: 12,
    },
});

function fillNum(num) {
    return num < 10 ? '0' + num : num;
}

type IProps = {
    pageRawData: PageRowData;
    isFrom?: string;
    showCouponMakeUpTip?: boolean;
    position?: 'optionBar' | 'specLinePop';
};
function useSubsidyCuntDown({ pageRawData }: { pageRawData: ItemInfo }) {
    const { hasSubsidy } = useSubsidy();
    const subsidyItem = pageRawData?.activityList?.find((v) => v?.marketingActivityType === ActivityType.Exclusive);
    const node = useMemo(() => {
        if (!hasSubsidy || !subsidyItem?.endTime) return null;
        const newTargetTimeStamp = Date.now() + subsidyItem?.endTime;
        return (
            <CountDownTag
                allTextStyle={{ fontSize: 14 }}
                textStyle={{ color: 'rgba(0,0,0,0.88)' }}
                boxStyle={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}
                leftTime={subsidyItem?.endTime}
                useTargetTime={true}
                endTimeStamp={newTargetTimeStamp}
            />
        );
    }, [hasSubsidy, subsidyItem?.endTime]);

    return {
        node,
    };
}
const BottomAreaTip = (props: IProps) => {
    const { pageRawData, isFrom = '', showCouponMakeUpTip = false, position = 'optionBar' } = props;
    const { deliveryState } = useDetailPageStore((s) => ({
        deliveryState: s.delivery,
    }));
    const showUgc = pageRawData?.displaySpuUgc;
    const { node: subsidyCuntDown } = useSubsidyCuntDown({ pageRawData });
    const { currentSku, purchaseQuantity, fetchData } = useDetailPageStore((s) => ({
        currentSku: s.currentSku,
        purchaseQuantity: s.purchaseQuantity,
        fetchData: s.fetchData,
    }));
    const { setState: setPageStore } = useDetailPageStore();
    const showFreeShippingTipWithThreshold = isFrom === 'recommendGoods-minCard' || isFrom === 'detail' || isFrom === 'shoppingCar';

    // showAbFlash标识是否命中商详页的ab实验。命中实验才展示秒杀腰带、秒杀进度条；没有命中ab实验，如果有秒杀活动，只展示秒杀价
    const { showFlash: showAbFlash } = useShowFlash();
    // 有活动id，并且活动状态是秒杀中才展示秒杀氛围模块（秒杀腰带和秒杀价）
    const [showFlash, setShowFlash] = useState(
        pageRawData?.activityInfo?.activityId &&
            showFlashActivity(pageRawData?.activityInfo?.status) &&
            pageRawData?.activityInfo?.saleRate <= 100 &&
            (pageRawData?.activityInfo?.marketingActivityType === 2001 || pageRawData?.activityInfo?.marketingActivityType === 2002),
    );

    const expireTime = pageRawData?.activityInfo?.endTime || undefined;

    // 秒杀倒计时
    const [__, flashFormattedRes] = useCountDown({
        leftTime: Math.round(expireTime / 1000) * 1000,
        interval: 1000,
        onEnd: () => {
            expireTime && fetchData?.({ noSke: true });
        },
        key: 'FLASH',
    });

    // 获取是否展示保障信息
    const { guaranteeStatus } = useShowGuarantee({ type: 'DETAIL' });

    useEffect(() => {
        const flash =
            pageRawData?.activityInfo?.activityId &&
            showFlashActivity(pageRawData?.activityInfo?.status) &&
            pageRawData?.activityInfo?.saleRate <= 100 &&
            (pageRawData?.activityInfo?.marketingActivityType === 2001 || pageRawData?.activityInfo?.marketingActivityType === 2002);
        if (flash !== showFlash) {
            setShowFlash(flash);
        }
    }, [pageRawData, pageRawData?.activityInfo]);

    // const [showFlash, setShowFlash] = useState(
    //     pageRawData?.activityInfo?.activityId && showFlashActivity(pageRawData?.activityInfo?.status) && pageRawData?.activityInfo?.saleRate <= 100,
    // );

    // 是否展示商详页底部利益点
    const { showBottomBenefits } = useShowBottomBenefits();

    const expireCoupon = pageRawData.expireCoupon || {};

    const [_c, couponCountDown] = useCountDown({
        leftTime: Math.round(expireCoupon?.retainTime / 1000) * 1000 ?? 0,
        interval: 1000,
        onEnd: () => {
            expireCoupon?.retainTime && fetchData({ noSke: true });
        },
        key: 'EXPIRECOUPON',
    });

    const [currentIndex, setCurrentIndex] = useState(0);
    const currentRef = useRef(0);
    const [nextIndex, setNextIndex] = useState(0);

    const configs = useMemo(() => {
        const _configs = [];
        if (isFrom === 'detail' && showBottomBenefits.flash_sale && showAbFlash && showFlash && __) {
            _configs.push({
                color: ['rgba(255, 73, 6, 0.08)', 'rgba(255, 73, 6, 0.00)'],
                textNode: (
                    <View style={styles.textarea}>
                        <View
                            style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'row',
                            }}
                        >
                            <Image source={flashPng} style={styles.bannerImage} />
                            {k18nPro({
                                text: '限时秒杀 {time} 结束',
                                id: 'k_370315',
                                outerStyle: styles.bannerText,
                                params: {
                                    time: (
                                        <Text
                                            style={{
                                                color: '#FF4906',
                                            }}
                                        >
                                            {fillNum(flashFormattedRes.days * 24 + flashFormattedRes.hours)} : {fillNum(flashFormattedRes.minutes)} :{' '}
                                            {fillNum(flashFormattedRes.seconds)}
                                        </Text>
                                    ),
                                },
                            })}
                        </View>
                    </View>
                ),
            });
        }
        if (isFrom === 'detail' && subsidyCuntDown) {
            _configs.push({
                color: ['rgba(255, 73, 6, 0.08)', 'rgba(255, 73, 6, 0.00)'],
                textNode: (
                    <View style={styles.textarea}>
                        {/* <View
                            style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'row',
                            }}
                        > */}
                        {subsidyCuntDown}
                        {/* </View> */}
                    </View>
                ),
            });
        }
        // 如果命中了https://docs.corp.kuaishou.com/d/home/fcACjgRIjzknMEmhMCgI3cIHt 实验，或者从短视频商品主卡过来的商详，就走该需求的运费券展示逻辑
        if ((pageRawData?.abTest?.addCartOnly && showFreeShippingTipWithThreshold) || showCouponMakeUpTip) {
            if (
                // 有运费券
                (pageRawData.discountCoupon as Array<any>)?.some((coupon) => coupon.discountFeeType === 3) ||
                // 运费为0
                deliveryState?.expressFeeAfterDiscount === 0 ||
                // 有商家运费折扣
                pageRawData.extraInfo.benefit?.includes(3)
            ) {
                if (
                    pageRawData?.shippingFeeView?.threshold &&
                    ((currentSku?.skuId && currentSku?.activityPrice * purchaseQuantity < pageRawData?.shippingFeeView?.threshold) ||
                        (!currentSku?.skuId && pageRawData?.activityPrice * purchaseQuantity < pageRawData?.shippingFeeView?.threshold) ||
                        (position === 'specLinePop' && !pageRawData?.abTest?.multipulButtonForSpecHalfScreen))
                ) {
                    _configs.push({
                        color: ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)'],
                        textNode: (
                            <View style={styles.textarea}>
                                {k18nPro({
                                    text: 'Add to cart to enjoy {freeshipping}.',
                                    id: 'k_465655',
                                    outerStyle: styles.specbannerText,
                                    params: {
                                        freeshipping: (
                                            <Text
                                                style={{
                                                    color: '#4CA7A2',
                                                }}
                                            >
                                                {$k18n({ id: 'free_shipping_upper', text: '包邮' })}
                                            </Text>
                                        ),
                                    },
                                })}
                            </View>
                        ),
                    });
                } else {
                    _configs.push({
                        color: ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)'],
                        textNode: (
                            <View style={styles.textarea}>
                                {k18nPro({
                                    text: '{shipping}, {buyNow}',
                                    noRunK18n: true,
                                    outerStyle: styles.specbannerText,
                                    params: {
                                        shipping: (
                                            <Text
                                                style={{
                                                    color: '#4CA7A2',
                                                }}
                                            >
                                                {$k18n({ id: 'free_shipping_upper', text: '包邮' })}
                                            </Text>
                                        ),
                                        buyNow: $k18n({ id: 'k_444060', text: '立即购买' }),
                                    },
                                })}
                            </View>
                        ),
                    });
                }
            }
        }
        // 如果没有命中上面的需求实验，再走https://docs.corp.kuaishou.com/d/home/fcADeDTH6pzexzpYvb6do1xbg 需求实验
        else if (
            isFrom === 'detail' &&
            showBottomBenefits.store_free_shipping &&
            ((pageRawData.discountCoupon as Array<any>)?.some((coupon) => coupon.discountFeeType === 3) ||
                deliveryState?.expressFeeAfterDiscount === 0 ||
                pageRawData.extraInfo.benefit?.includes(3))
        ) {
            _configs.push({
                color: ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)'],
                textNode: (
                    <View style={styles.textarea}>
                        {k18nPro({
                            text: '{shipping}, {buyNow}',
                            noRunK18n: true,
                            outerStyle: styles.specbannerText,
                            params: {
                                shipping: (
                                    <Text
                                        style={{
                                            color: '#4CA7A2',
                                        }}
                                    >
                                        {$k18n({ id: 'free_shipping_upper', text: '包邮' })}
                                    </Text>
                                ),
                                buyNow: $k18n({ id: 'k_444060', text: '立即购买' }),
                            },
                        })}
                    </View>
                ),
            });
        }
        if (isFrom === 'detail' && showBottomBenefits.shipping_coupon && expireCoupon?.discountFeeType && _c) {
            _configs.push({
                color:
                    expireCoupon.discountFeeType === 3
                        ? ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)']
                        : ['rgba(255, 73, 6, 0.08)', 'rgba(255, 73, 6, 0.00)'],
                textNode: (
                    <View style={styles.textarea}>
                        {k18nPro({
                            id: expireCoupon.discountFeeType === 3 ? 'k_444062' : 'k_444061',
                            text: expireCoupon.discountFeeType === 3 ? '{free_shipping}券过期倒计时{time}' : '{product_amt}商品券过期倒计时{time}',
                            outerStyle: styles.specbannerText,
                            params: {
                                [expireCoupon.discountFeeType === 3 ? 'free_shipping' : 'product_amt']: expireCoupon.displayMaxDeductAmount,
                                time: (
                                    <Text
                                        style={{
                                            color: expireCoupon.discountFeeType === 3 ? '#4CA7A2' : '#FF4906',
                                        }}
                                    >
                                        {fillNum(couponCountDown.days * 24 + couponCountDown.hours)} : {fillNum(couponCountDown.minutes)} :{' '}
                                        {fillNum(couponCountDown.seconds)}
                                    </Text>
                                ),
                            },
                        })}
                    </View>
                ),
            });
        }
        if (isFrom === 'detail' && showBottomBenefits.local_product) {
            _configs.push({
                color: ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)'],
                textNode: (
                    <View style={styles.textarea}>
                        {k18nPro({
                            text: '{shipping}, {buyNow}',
                            noRunK18n: true,
                            outerStyle: styles.specbannerText,
                            params: {
                                shipping: (
                                    <Text
                                        style={{
                                            color: '#4CA7A2',
                                        }}
                                    >
                                        {$k18n({ text: '本地发货', id: 'k_444059' })}
                                    </Text>
                                ),
                                buyNow: $k18n({ id: 'k_444060', txet: '立即购买' }),
                            },
                        })}
                    </View>
                ),
            });
        }
        const itemTags = pageRawData.tagInfoAgg?.itemTag;
        const priceTags = pageRawData.tagInfoAgg?.priceTag;
        if (isFrom === 'detail' && (itemTags || priceTags)) {
            const list = [...itemTags, ...priceTags].filter(Boolean);
            if (list.length) {
                _configs.push(
                    ...list.map((v) => {
                        return {
                            color: ['rgba(255, 73, 6, 0.08)', 'rgba(255, 73, 6, 0.00)'],
                            textNode: (
                                <View style={styles.textarea}>
                                    <Text style={styles.specbannerText}>{v.tips}</Text>
                                </View>
                            ),
                        };
                    }),
                );
            }
        }
        if (isFrom === 'detail' && showUgc) {
            const text = String(pageRawData?.displaySpuUgc)?.replace(/([\d]*%)/, '{percentage}') || null;
            const percentage = String(pageRawData?.displaySpuUgc)?.match(/([\d]*%)/g)?.[0];
            text &&
                _configs.push({
                    color: ['rgba(76, 167, 162, 0.16)', 'rgba(76, 167, 162, 0.00)'],
                    textNode: (
                        <View style={styles.textarea}>
                            {k18nPro({
                                text,
                                noRunK18n: true,
                                outerStyle: styles.specbannerText,
                                params: {
                                    percentage: <Text style={{ color: '#FF4906' }}>{percentage}</Text>,
                                },
                            })}
                        </View>
                    ),
                });
        }
        if (isFrom === 'detail' && guaranteeStatus) {
            _configs.push({
                color: ['rgba(5,163,0,0.12)', 'rgba(5,163,0,0.00)'],
                textNode: (
                    <View style={styles.guaranteeArea}>
                        <Text style={{ color: '#05A300' }}>
                            {$k18n({ text: '放心购买', id: 'k_511446' })}·{$k18n({ text: '物流保障', id: 'k_511447' })}
                        </Text>
                    </View>
                ),
            });
            _configs.push({
                color: ['rgba(5,163,0,0.12)', 'rgba(5,163,0,0.00)'],
                textNode: (
                    <View style={styles.guaranteeArea}>
                        <Text style={{ color: '#05A300' }}>
                            {$k18n({ text: '退货无忧', id: 'k_511448' })}·{$k18n({ text: '购物安全', id: 'k_511458' })}
                        </Text>
                    </View>
                ),
            });
        }
        setPageStore({ bottomAreaTipConfigLength: _configs.length });
        return _configs;
    }, [
        showUgc,
        showBottomBenefits.flash_sale,
        showBottomBenefits.store_free_shipping,
        showBottomBenefits.shipping_coupon,
        showAbFlash,
        showFlash,
        flashFormattedRes.seconds,
        deliveryState?.expressFeeAfterDiscount,
        expireCoupon.discountFeeType,
        expireCoupon.displayMaxDeductAmount,
        _c,
        pageRawData?.displaySpuUgc,
        currentSku,
        purchaseQuantity,
        isFrom,
        __,
    ]);

    const interval = useRef(null);
    const animatedVale = useRef(new Animated.Value(0));

    useEffect(() => {
        if (interval.current) clearInterval(interval.current);
        // TODO Render好多次
        interval.current = setInterval(() => {
            setCurrentIndex(currentRef.current % configs.length);
            if (currentRef.current === (currentRef.current + 1) % configs.length) return;
            currentRef.current = currentRef.current + 1;
            animatedVale.current.setValue(0);
            setNextIndex(currentRef.current % configs.length);
            if (configs.length > 1) {
                Animated.timing(animatedVale.current, {
                    toValue: 1,
                    duration: 500,
                    easing: Easing.linear,
                    useNativeDriver: false,
                    isInteraction: true,
                }).start();
            }
        }, 3500);
        return () => {
            if (interval.current) clearInterval(interval.current);
        };
    }, [configs.length]);

    const moveDistance = animatedVale.current.interpolate({
        inputRange: [0, 1],
        outputRange: [0, -32],
    });

    useEffect(() => {
        if (!configs[nextIndex]) setNextIndex(0);
        if (!configs[currentIndex]) setCurrentIndex(0);
    }, [configs[nextIndex], configs[currentIndex]]);

    return (
        <PageContext.Provider value={{ Styles }}>
            {configs[nextIndex] && configs[currentIndex] ? (
                <KView rtlClassName={'bottom-tip'}>
                    <AnimatedGradientTransition
                        colors={configs[nextIndex]?.color ?? configs[0].color}
                        style={[styles.linearWrap]}
                        animation={{ toValue: 1, duration: 500, easing: Easing.linear }}
                    >
                        <View style={{ height: 32, position: 'relative', overflow: 'hidden' }}>
                            <Animated.View
                                style={{
                                    position: 'absolute',
                                    height: 32,
                                    top: 0,
                                    width: '100%',
                                    transform: [{ translateY: moveDistance }],
                                }}
                            >
                                {configs[currentIndex]?.textNode ?? configs[0]?.textNode}
                            </Animated.View>
                            <Animated.View
                                style={{
                                    position: 'absolute',
                                    height: 32,
                                    top: 32,
                                    width: '100%',
                                    transform: [{ translateY: moveDistance }],
                                }}
                            >
                                {configs[nextIndex]?.textNode ?? configs[0]?.textNode}
                            </Animated.View>
                        </View>
                    </AnimatedGradientTransition>
                </KView>
            ) : null}
        </PageContext.Provider>
    );
};

export default BottomAreaTip;
